import { api } from "@/lib/api/client";
import { partnerEndpoints } from "@/lib/api/endpoints";
import type { CompanyTypeOption } from "@/types/application";

export async function listCompanyTypes(): Promise<CompanyTypeOption[]> {
  const data = await api.get<CompanyTypeOption[] | { results: CompanyTypeOption[] }>(
    partnerEndpoints.companyTypes,
  );
  if (Array.isArray(data)) return data;
  return data.results ?? [];
}
